import React, { useMemo, useReducer } from 'react';
import DialogRenderer from './DialogRenderer';
import { DialogsContext } from './DialogsContext';
const initialStates = {
  DialogComponent: null,
  dialogProps: null,
  isOpen: false
};
function dialogReducer(state, action) {
  var _action$payload, _action$payload2;
  switch (action.type) {
    case 'open':
      return {
        ...state,
        DialogComponent: ((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.DialogComponent) || null,
        dialogProps: ((_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.dialogProps) || null,
        isOpen: true
      };
    case 'close':
      return {
        ...state,
        DialogComponent: null,
        dialogProps: null,
        isOpen: false
      };
    default:
      throw new Error();
  }
}
export default function DialogsProvider(props) {
  const {
    children
  } = props;
  const [stateDialogProvider, dispatch] = useReducer(dialogReducer, initialStates);
  const valueProvider = useMemo(() => ({
    openDialog: (DialogComponent, dialogProps = null) => dispatch({
      type: 'open',
      payload: {
        DialogComponent,
        dialogProps
      }
    }),
    closeDialog: () => dispatch({
      type: 'close'
    })
  }), []);
  return (
    /*#__PURE__*/
    // @ts-ignore
    React.createElement(DialogsContext.Provider, {
      value: valueProvider
    }, children, /*#__PURE__*/React.createElement(DialogRenderer, stateDialogProvider))
  );
}